import { useMemo } from 'react';
import { isEqual } from 'lodash';

export const isDataDirty = (data: any, draftData: any) =>
  useMemo(() => !isEqual(data, draftData), [data, draftData]);
